export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8138.3f3627a6.jpg";